module.exports = __webpack_public_path__ + "img/PPMP8.ccc43585.png";